module.exports = __webpack_public_path__ + "static/media/w_0.ec0a2138.png";